<template>
    <LoadingCard v-if="loading" />
    <div v-else>
        <div class="toolbar">
            <div class="toolbar__label">
                Processed Regions
            </div>
            <div class="actions">
                <i class="actions__item zmdi zmdi-search" @click="enableSearch"></i>
            </div>

            <div class="toolbar__search" :class="searchEnabled ? 'd-block' : 'd-none'">
                <input type="text" placeholder="Search..." ref="searchInput" v-model="searchTerm">
                <i class="toolbar__search__close zmdi zmdi-long-arrow-left" @click="disableSearch"></i>
            </div>
        </div>

        <div class="card">
            <div class="card-header bg-primary text-white">
                Regions
            </div>

            <b-table small hover stacked="md" :items="filteredData" :fields="table.fields" sort-by="name" :show-empty="true"
                     @row-clicked="handleRegionToggle">

                <template slot="name" slot-scope="row">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               :id="`region${row.item.id}`" type="checkbox"
                               :checked="linkedRegions.includes(row.item.id)"
                        >
                        <label class="custom-control-label" :for="`region${row.item.id}`">{{ row.item.name }}</label>
                    </div>
                </template>

                <template slot="country" slot-scope="row">
                    <span>
                        {{ row.item.country.name }}
                    </span>
                </template>

            </b-table>

        </div>

    </div>
</template>
<script>
import createProcessorRegionLinkMutation from '@views/Setup/RegionManager/mutationCreateProcessorRegionLink.graphql';
import deleteProcessorRegionLinkMutation from '@views/Setup/RegionManager/mutationDeleteProcessorRegionLink.graphql';
import listLinkedRegionsQuery from '@views/Setup/RegionManager/queryListProcessorLinkedRegions.graphql';
import listRegionsQuery from '@views/Setup/RegionManager/queryListRegions.graphql';

export default {
  name: 'RegionManager',

  apollo: {
    allRegions: {
      query: listRegionsQuery,
      update: data => data.filterRegions.data,
    },
    linkedRegions: {
      query: listLinkedRegionsQuery,
      update: data => data.filterProcessorRegionLinks.map(item => item.id),
    },
  },
  data() {
    return {
      allRegions: [],
      linkedRegions: [],
      loading: 0,
      searchEnabled: false,
      searchTerm: '',
      table: {
        fields: [
          { key: 'name', label: 'Region', sortable: true },
          { key: 'country', label: 'Country', sortable: true },
        ],
      },
    };
  },
  computed: {
    filteredData() {
      const subjectMatchesSearch = subject => {
        return (
          this.searchTerm.length === 0 ||
          subject.name
            .toLowerCase()
            .includes(this.searchTerm.toLowerCase())
        );
      };

      return this.allRegions
        .filter(subjectMatchesSearch)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(region => ({
          ...region,
        }));
    },
  },
  methods: {
    enableSearch() {
      this.searchEnabled = true;
      this.$nextTick(() => this.$refs.searchInput.focus());
    },
    disableSearch() {
      this.searchTerm = '';
      this.searchEnabled = false;
    },
    handleRegionToggle(region) {
      if (this.linkedRegions.includes(region.id)) {
        this.unlinkRegion(region);
      } else {
        this.linkRegion(region);
      }
    },
    unlinkRegion(region) {
      this.$apollo.mutate({
        mutation: deleteProcessorRegionLinkMutation,
        variables: {
          input: {
            id: region.id,
          },
        },
        update: (
          store,
          { data: { deleteProcessorRegionLink: unlinkedRegion } },
        ) => {
          const data = store.readQuery({
            query: listLinkedRegionsQuery,
          });
          const indexToRemove = data.filterProcessorRegionLinks.findIndex(
            item => item.id === unlinkedRegion.id,
          );
          if (indexToRemove !== -1) {
            data.filterProcessorRegionLinks.splice(indexToRemove, 1);
          }
          store.writeQuery({ query: listLinkedRegionsQuery, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          deleteProcessorRegionLink: {
            __typename: 'Region',
            ...region,
          },
        },
      });
    },
    linkRegion(region) {
      this.$apollo.mutate({
        mutation: createProcessorRegionLinkMutation,
        variables: {
          input: {
            id: region.id,
          },
        },
        update: (
          store,
          { data: { createProcessorRegionLink: linkedRegion } },
        ) => {
          const data = store.readQuery({
            query: listLinkedRegionsQuery,
          });
          data.filterProcessorRegionLinks.push(linkedRegion);
          store.writeQuery({ query: listLinkedRegionsQuery, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          createProcessorRegionLink: {
            __typename: 'Region',
            ...region,
          },
        },
      });
    },
  },
};
</script>
